import { useState, useEffect } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import './style.css';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import Footer from "components/footers/Footer.jsx";

const AdminAnnouncement = () => {
    const { t } = useTranslation();

    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [announcements, setAnnouncements] = useState([]);

    useEffect(() => {
        checkAdminStatus();
    }, []);

    useEffect(() => {
        if (isAdmin) {
            fetchAnnouncements();
        }
    }, [isAdmin]);

    const checkAdminStatus = () => {
        const isAdminStored = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdminStored);

        if (!isAdminStored) {
            setErrorMessage(t('unauthorized_message'));
            console.error('Unauthorized access: User is not an admin');
        }
    };

    const fetchAnnouncements = async () => {
        if (!isAdmin) return;

        const token = localStorage.getItem('authToken');
        if (!token) {
            console.error('No auth token found');
            return;
        }

        try {
            const response = await axios.post('https://rehabwmg.online/api/admin/allannouncement', {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            setAnnouncements(response.data);
        } catch (error) {
            console.error('Error fetching announcements:', error.response?.data || error.message);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isAdmin) {
            alert(t('unauthorized_message'));
            return;
        }

        const token = localStorage.getItem('authToken');
        if (!token) {
            alert(t('auth_token_missing'));
            return;
        }

        const payload = {
            title: title,
            message: message
        };

        try {
            const response = await axios.post('https://rehabwmg.online/api/admin/announcement',
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    }
                });

            Swal.fire({
                title: t('success'),
                text: t('announcement_posted'),
                icon: 'success',
                confirmButtonText: t('ok'),
            });
            setTitle('');
            setMessage('');
            window.location.reload();
        } catch (error) {
            console.error('Error posting announcement:', error.response?.data || error.message);
            alert(t('error_posting_announcement'));
        }
    };

    const toggleActive = async (announcementId, currentStatus) => {
        const token = localStorage.getItem('authToken');
        if (!token) {
            alert(t('auth_token_missing'));
            return;
        }

        try {
            const response = await axios.put(
                `https://rehabwmg.online/api/admin/announcement/${announcementId}/toggle-active`,
                {},
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                }
            );

            setAnnouncements(prev =>
                prev.map(ann =>
                    ann.id === announcementId ? { ...ann, is_active: response.data.is_active } : ann
                )
            );
        } catch (error) {
            console.error('Error toggling active status:', error.response?.data || error.message);
            alert(t('failed_update_active_status'));
        }
    };

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div>
                {errorMessage ? (
                    <div style={{
                        backgroundColor: '#4e7662',
                        color: 'white',
                        padding: '10px',
                        textAlign: 'center',
                        fontWeight: 'bold'
                    }}>
                        {errorMessage}
                    </div>
                ) : (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <div className="container w-100 w-md-75 p-3">
                            <div className="card shadow-lg">
                                <div className="card-header text-center fs-4">{t('create_announcement')}</div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="small mb-1" htmlFor="name">{t('title')}</label>
                                            <input
                                                className="form-control form-control-lg"
                                                id="name"
                                                type="text"
                                                value={title}
                                                onChange={(e) => setTitle(e.target.value)}
                                                placeholder={t('announcement_title_placeholder')}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="small mb-1" htmlFor="message">{t('message')}</label>
                                            <textarea
                                                id="message"
                                                className="form-control form-control-lg"
                                                placeholder={t('announcement_message_placeholder')}
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <button
                                            className="btn btn-lg w-100"
                                            style={{ backgroundColor: '#4e7662N', color: 'white', border: 'none' }}
                                            type="submit"
                                        >
                                            {t('publish')}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="container mt-5">
                <h2 style={{ color: '#000000', fontSize: '40px', textAlign: 'center' }}>
                    📰 {t('all_announcements')}
                </h2>
                <br />
                {announcements.length === 0 ? (
                    <div className="alert alert-info">{t('no_announcements')}</div>
                ) : (
                    <div className="table-responsive shadow-sm rounded">
                        <table className="table table-hover table-bordered align-middle text-center rounded">
                            <thead className="table-light">
                                <tr>
                                    <th>{t('id')}</th>
                                    <th>{t('title')}</th>
                                    <th>{t('message')}</th>
                                    <th>{t('created_at')}</th>
                                    <th>{t('active')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {announcements.map((ann) => (
                                    <tr key={ann.id || ann.id_announcement}>
                                        <td className="fw-semibold">{ann.id || ann.id_announcement}</td>
                                        <td>{ann.title}</td>
                                        <td className="text-start">{ann.message}</td>
                                        <td>{new Date(ann.created_at).toLocaleString()}</td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={ann.is_active}
                                                onChange={() =>
                                                    toggleActive(ann.id || ann.id_announcement, ann.is_active)
                                                }
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
<Footer/>
        </AnimationRevealPage>
    );
};

export default AdminAnnouncement;
